import React, { Component } from "react";
import axios from "axios";
import { Row, Col, Image, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import PresentationModalContainer from "./PresentationModalContainer.jsx";
import OverviewPresentationModalContainer from "./OverviewPresentationModalContainer.jsx";
import months from "../../../src/util/months";



export default class MemberCard extends Component {
    render() {
        const member = this.props.member;
        let topLabel;
        if (this.props.showNames && (this.props.filterGroup || "blank").toLowerCase() != "board members" && member.advisory_board) {
            topLabel = <div className="top-label">Advisory Board</div>;
        }

        if (this.props.showNames && (this.props.filterGroup || "blank").toLowerCase() != "board members" && member.foundation_partner) {
            topLabel = <div className="top-label foundation-partner">Foundation Partner</div>;
        }

        let className = "member";
        if (this.props.showNames) className += " show-names";
        if (this.props.expanded) className += " expanded";

        let basicContent;
        if (this.props.showNames && !this.props.expanded) {
            const tooltip = <Tooltip id={`tooltip${this.props.cardId}`}>{member.name}</Tooltip>;
            basicContent = (
                <OverlayTrigger placement="bottom" overlay={tooltip}>
                    <div className={className} onClick={this.props.handleClick} data-card-id={this.props.cardId}>
                        {topLabel}
                        <div className="img-wrapper">
                          <Image src={member.fingerprinted_logo} responsive />
                        </div>
                    </div>
                </OverlayTrigger>
            );
        } else {
            basicContent = (
                <div className={className} onClick={this.props.handleClick} data-card-id={this.props.cardId}>
                    {topLabel}
                    <div className="img-wrapper">
                      <Image src={member.fingerprinted_logo} responsive />
                    </div>
                </div>
            );
        }

        if (this.props.expanded) {
            const memberSince = new Date(member.member_since);

            let contactMember;
            if (this.props.currentUser) {
                const tooltip = <Tooltip id={`contact-tooltip${this.props.cardId}`}>To contact this utility use our messaging app</Tooltip>;
                contactMember = (
                    <OverlayTrigger placement="top" overlay={tooltip}>
                        <Button className="contact-member" onClick={this.props.contactButtonClick}>Go to messages</Button>
                    </OverlayTrigger>
                );
            } else {
                contactMember = <Button className="contact-member" onClick={this.props.contactButtonClick}>Contact</Button>;
            }

            let innovationAreas;
            if (member.innovation_areas) {
                innovationAreas = member.innovation_areas.map((area, i) => {
                    const areaPresentationForMember = area.presentations.find(presentation => presentation.member_id == member.id);
                    if (areaPresentationForMember) {
                        return <PresentationModalContainer area={area} presentation={areaPresentationForMember} key={`innovationArea${i + 1}`} />;
                    } else {
                        return <div className="name" key={`innovationArea${i + 1}`}>{area.name}</div>;
                    }
                });
            }

            let innovationAreasSection;
            if (member.organisation_type == "Utility") {
                innovationAreasSection = (
                    <div>
                        <div className="innovation-areas-heading">Innovation areas this utility is involved in</div>
                        <div className="innovation-areas">{innovationAreas}</div>
                    </div>
                );
            }

            let memberSinceDiv;
            if (member.organisation_type != "Sponsor") {
                memberSinceDiv = <div className="member-since">Member since {months[memberSince.getMonth()]} {memberSince.getFullYear()}</div>;
            }

            let overviewPresentation;
            if (member.overview_presentation) {
                overviewPresentation = <OverviewPresentationModalContainer area={`${member.name} Overview`} presentation={member.overview_presentation} />;
            }

            const goToWebsiteButtonClickHandler = (e) => {
              e.preventDefault();
              e.stopPropagation();
              axios.post("/analytics_messages.json", { type: 'go-to-website', member_id: member.id });

              window.open(member.hyperlink, '_blank');
              if (member.hyperlink2) window.open(member.hyperlink2, '_blank');
            };

            return (
                <Col md={12} className="expanded member-card">
                    <Row className="expanded-content">
                        {this.props.tab}
                        <Col md={4}>
                            {basicContent}
                            <span className="country">{member.country}</span>
                            {contactMember}
                            {overviewPresentation}
                            <Button className="go-to-website" href={member.hyperlink} onClick={goToWebsiteButtonClickHandler} target="_blank">Go to website</Button>
                            {memberSinceDiv}
                        </Col>
                        <Col md={8}>
                            <div className={member.organisation_type == "Utility" ? "close" : ""} onClick={this.props.handleClick}></div>
                            <span className="about-utility-heading">About {member.name}</span>
                            <div className="about-utility-content" dangerouslySetInnerHTML={{ __html: (this.props.description || member.description || "").replace(/(&#8203;|&#65279;)/, "") }}></div>
                            {innovationAreasSection}
                        </Col>
                    </Row>
                </Col>
            );
        } else {
            return (
                <Col className="member-card" md={4}>
                    {basicContent}
                </Col>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/MemberCard.jsx.erb